<template>
  <v-dialog
    :model-value="state.open"
    :persistent="options.persistent"
    :width="options.width"
    @after-leave="service.afterLeave"
    @update:model-value="onModelValueChange"
  >
    <v-card v-if="request">
      <v-toolbar class="py-2" :color="`${mode}-container`" density="compact">
        <v-icon class="ml-4" :icon="options.icon ?? MODE_ICONS[mode]" />
        <v-toolbar-title v-if="options.title">
          {{ options.title }}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text class="confirm-dialog__content pb-3">
        <div class="confirm-dialog__message" v-html="request.message" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <CelusTextButton v-if="options.buttonFalseText" @click="choose(false)">
          {{ options.buttonFalseText }}
        </CelusTextButton>
        <component
          :is="mode === 'error' ? CelusErrorButton : CelusPrimaryButton"
          @click="choose(true)"
        >
          {{ options.buttonTrueText }}
        </component>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import CelusErrorButton from "@/components/util/CelusErrorButton.vue";
import CelusPrimaryButton from "@/components/util/CelusPrimaryButton.vue";
import CelusTextButton from "@/components/util/CelusTextButton.vue";
import { ICONS } from "@/libs/icons";
import { useConfirmService } from "@/plugins/confirm";
import { computed } from "vue";

const MODE_ICONS = {
  info: ICONS.info,
  warning: ICONS.warning,
  error: ICONS.error,
  success: ICONS.success,
};

const service = useConfirmService();
const state = service.state;
const request = computed(() => state.current);
const options = computed(() => request.value?.options ?? {});
const mode = computed(() =>
  options.value.mode in MODE_ICONS ? options.value.mode : "warning",
);

function choose(result) {
  service.settle(result);
}

function onModelValueChange(value) {
  if (!value && state.open) {
    choose(false);
  }
}
</script>

<style scoped>
.confirm-dialog__content {
  padding-top: 12px !important;
}

.confirm-dialog__message {
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  font-size: 1rem;
  letter-spacing: 0.03125em;
  line-height: 1.5;
}
</style>
